import { render, staticRenderFns } from "./Kirjaudu.vue?vue&type=template&id=365a6cd6&scoped=true&"
import script from "./Kirjaudu.vue?vue&type=script&lang=js&"
export * from "./Kirjaudu.vue?vue&type=script&lang=js&"
import style0 from "./Kirjaudu.vue?vue&type=style&index=0&id=365a6cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365a6cd6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365a6cd6')) {
      api.createRecord('365a6cd6', component.options)
    } else {
      api.reload('365a6cd6', component.options)
    }
    module.hot.accept("./Kirjaudu.vue?vue&type=template&id=365a6cd6&scoped=true&", function () {
      api.rerender('365a6cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Kirjaudu.vue"
export default component.exports